import { render, staticRenderFns } from "./PanelInfoForm.vue?vue&type=template&id=16d1e803&"
import script from "./PanelInfoForm.vue?vue&type=script&lang=js&"
export * from "./PanelInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d1e803')) {
      api.createRecord('16d1e803', component.options)
    } else {
      api.reload('16d1e803', component.options)
    }
    module.hot.accept("./PanelInfoForm.vue?vue&type=template&id=16d1e803&", function () {
      api.rerender('16d1e803', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/panel/PanelInfoForm.vue"
export default component.exports